/* import __COLOCATED_TEMPLATE__ from './box-delete.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { getOwner } from '@ember/owner';
import { task } from 'ember-concurrency';
import apiAction from 'vagrant/utils/ec-macros/api-action';
import { waitForOperation } from 'vagrant/utils/api-helpers';
let BoxDeleteModal = (_dec = apiAction('box.delete.error.message', 'box.delete.success.message'), _class = class BoxDeleteModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "api", _descriptor, this);
    _initializerDefineProperty(this, "vagrantContext", _descriptor2, this);
    _initializerDefineProperty(this, "router", _descriptor3, this);
    _initializerDefineProperty(this, "operation", _descriptor4, this);
    _initializerDefineProperty(this, "isValid", _descriptor5, this);
  }
  // Called when the confirm text updates
  validate(valid) {
    this.isValid = valid;
  }
  *deleteBox() {
    const registryId = this.vagrantContext.registry?.name;
    const boxId = this.args.box.name;
    if (!registryId || !boxId) return;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const {
      operation
    } = yield this.api.vagrant.registryServiceApi.deleteBox(registryId, boxId);

    // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
    yield* waitForOperation(this.operation, operation.id);

    // TODO: Replace with router.refresh('route') (https://github.com/villander/ember-engines-router-service/pull/84)
    const route = getOwner(this)?.lookup('route:registries.registry.boxes.index');

    // Don't wait for the refresh, transition immediately.
    route?.refresh();
    this.router.transitionTo('registries.registry.boxes.index', registryId);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "api", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "vagrantContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "operation", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isValid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "validate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "validate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteBox", [task, _dec], Object.getOwnPropertyDescriptor(_class.prototype, "deleteBox"), _class.prototype), _class);
export { BoxDeleteModal as default };